import React from 'react'
import { config } from '../../../config/config'

const Appstore = ({ information }) => {
    return (
        <a href={information.provider.urlApple} className="self-start basis-[48.5%] h-[40px]" rel="noreferrer" target={'_blank'}>
            <img
                id={config.content.provider_popup.appstore.id}
                alt={config.content.provider_popup.appstore.alt}
                className='h-full'
            />
        </a>
    )
}

export default Appstore
